import type { FC } from 'react'
import type { MediaFolder } from '@/features/media-file/domain/models/media-folder'

const MediaFilesPathchain: FC<{
  chain?: MediaFolder[] | undefined
}> = ({ chain }) => {
  const path = (chain ?? [])
    .map(({ parentFolderId, name }) => (parentFolderId ? name : ''))
    .reverse()
    .filter((name) => name !== '')
    .join(' / ')
  return (
    <span className="flex-1 truncate text-sm font-medium text-white">
      {path}
    </span>
  )
}

export default MediaFilesPathchain
